import React from 'react';
import _ from 'lodash';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LayoutContainer from '../../components/LayoutContainer';
import Box from '../../components/Box';
import Button from '../../components/Button';
import Teaser from '../../components/Teaser';
import MainContainer from '../../components/MainContainer';
import Logo from '../../components/Logo';
import DisplayIban from '../../components/DisplayIban';
import {destroySession} from '../../reducer';
import Title from '../../components/Title';
import useScrollToTop from '../../hooks/useScrollToTop';
import {withTheme} from 'styled-components';
import DJSBSideBar from '../../components/DJSBSideBar';
import CollectingSideBar from '../../components/CollectingSideBar';
import DonationBoxSideBar from '../../components/DonationBoxSideBar';
import {Helmet} from 'react-helmet';
import CollectingImage from '../../components/CollectingImage';

const DonationAlreadyCompleted = ({formContext, dmBoxInfo, collectorInfo, startNewDonation, history, isProductForm, theme}) => {
  useScrollToTop();
  const donationType = isProductForm ? 'bestelling' : 'donatie';
  return <>
    {(formContext.isDonationBox && dmBoxInfo?.boxHeader_txt) && <Helmet>
      <title>{dmBoxInfo?.boxHeader_txt}</title>
    </Helmet>}
    <MainContainer
      backgroundImageUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageUrl}
      backgroundImageTabletUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageTabletUrl}
      backgroundImageMobileUrl={theme?.donationBox?.imageAsBackground && formContext.isDonationBox && dmBoxInfo?.image?.publicUrl
        ? dmBoxInfo.image.publicUrl
        : formContext.backgroundImageMobileUrl}
    />
    <LayoutContainer
      position={formContext.textPosition}
      header={<div>
        <div style={{float: 'left', display: 'inline-block'}}>
          <Logo url={formContext.websiteUrl} />
        </div>
        {formContext.isCollecting && theme?.collecting?.imageTopRight &&
          <div style={{float: 'right', display: 'inline-block'}}><CollectingImage collectorInfo={collectorInfo} /></div>}
        <DisplayIban iban='NL08 INGB 0000 0005 55' />
      </div>}
      content={<><Box position={formContext.textPosition}
        hasTeaser={!_.isNil(formContext.pageTeaserHeader) || !_.isNil(formContext.pageTeaserBodyText) || !_.isEmpty(formContext.pageTeaserCarouselItems)}>
        {!theme?.title?.showInBody && <Title title={formContext.step1Header} />}
        <div className='widgetContent invalidFlow'>
          <h1>Bedankt voor je {donationType}</h1>
          <p>Je {donationType} is succesvol afgerond. Middels onderstaande knop kan je een nieuwe {donationType} doen.
          </p>
          <Button label={`Start nieuwe ${donationType}`} onClick={() => {
            startNewDonation(history);
          }} />
        </div>
      </Box>
        {formContext.allowCallToAction &&
          <div dangerouslySetInnerHTML={{__html: formContext.callToAction}} />}
      </>}
      sidebar={<>
        {theme?.djsb?.showDJSB && <DJSBSideBar formContext={formContext}/>}
        {formContext.showCollectingWidget
          ? <CollectingSideBar collectorInfo={collectorInfo}><Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} /></CollectingSideBar>
          : formContext.isDonationBox
            ? <DonationBoxSideBar dmBoxInfo={dmBoxInfo} header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText}>
                <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} /></DonationBoxSideBar>
            : <Teaser header={formContext.pageTeaserHeader} body={formContext.pageTeaserBodyText} formContext={formContext} />}
      </>}
      footer={formContext.footer}
      formContext={formContext}
    />

  </>;
};

const mapStateToProps = (state) => {
  return {
    formContext: state.reducer.formContext,
    isProductForm: state.reducer.isProductForm
  };
};

const mapDispatchToProps = (dispatch) => ({
  startNewDonation: (history) => {
    dispatch(destroySession(history));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withTheme(DonationAlreadyCompleted)));
